import React from 'react';
import styled from 'styled-components';
import { useTextViewStore } from '../../shared/store/TextViewStore';
import { useTextBlockImageDrop } from '../../shared/hooks/useTextBlockImageDrop';
import TextImageDropLayer from './TextImageDropLayer';

export interface TextViewerShellProps {
  children: React.ReactNode;
}

/** Texts 우측 패널(TextViewer / MultiTextViewer / IndexTextViewer) 래퍼 */
const TextViewerShell: React.FC<TextViewerShellProps> = ({ children }) => {
  const isLargeBody = useTextViewStore((s) => s.isLargeBody);
  const {
    isImageDragActive,
    remainingImageCount,
    onDragEnter,
    onDragOver,
    onDragLeave,
    onDrop,
  } = useTextBlockImageDrop();

  return (
    <Outer
      $isExtended={isLargeBody}
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      <Shell>{children}</Shell>
      <TextImageDropLayer
        isVisible={isImageDragActive}
        remainingCount={remainingImageCount}
      />
    </Outer>
  );
};

const Outer = styled.div<{ $isExtended: boolean }>`
  position: relative;
  width: ${({ $isExtended }) => ($isExtended ? 'calc(38vw * 1.2)' : '38vw')};
  max-width: ${({ $isExtended }) => ($isExtended ? '720px' : '600px')};
  height: 100%;
  flex-shrink: 0;
  transition: width 0.3s ease, max-width 0.3s ease;
`;

const Shell = styled.section`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  padding-bottom: 40px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
`;

export default TextViewerShell;
